import { TranslateService } from '@ngx-translate/core';
import { ClinicalDocument, ClinicalDocumentData } from './clinical-document.model';

export class Script extends ClinicalDocument {
  public readonly type = 'script';

  constructor(
    data: ClinicalDocumentData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
  }

  public get label() {
    return this.translateService.instant('script_label', { doctor: this.doctor });
  }
}
